import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { Tenant } from "../matwins-tenant/Tenant.model";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, Validation, NavigationProperty, NestedProperty } from "../../decorators/EntityDecorators";
import { RegexType } from "../../services/RegexPatternLibrary";
import { Account } from "./Account.model";
import { AdminTenantInfoDTO } from "./AdminTenantInfoDTO.model";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";
import { Employee } from "../matwins-tenant/Employee.model";


@Register({
  isModelEntity: true, namespace: 'Manager', entityName: 'Client' // optionnel car par defaut utilise le nom de classe
})
export class Client extends GenericEntityBase<string> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly,
      // IPropretyAttribute.SortColumn
    ]
  })
  id: string = GenericEntityBase.GetDefaultId(KeyType.string);

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "Organization Name"
  })
  @Validation({
    propertyType: RegexType.StartsWithCapital,               //    Avec Auto-completion !!!
    minLength: 2,
    maxLength: 50,
    pattern: '^[A-Za-z][A-Za-z0-9 @#\$%&\*\-_\+\./\?!]{2,49}$',
  })
  organizationName!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "Url"
  })
  @Validation({
    propertyType: `${RegexType.Alphabetic}|${RegexType.WithSpecialChars}`,            //    Combinaisons typées
    pattern: '^https?://.+\..+$'
  })
  url!: string;


  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ]
  })
  @Validation({
    pattern: '^[a-z0-9]+$'      // Pattern 
  })
  prefix!: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn
    ],
    PropretyDisplayName: "Site Root Path"
  })
  @Validation({
    propertyType: RegexType.Alphanumeric,            //    Combinaisons typées
  })
  siteRootPath?: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn
    ],
    PropretyDisplayName: "Database Connection String"
  })
  @Validation({
    propertyType: RegexType.StartsWithLetter,            //    Combinaisons typées
  })
  databaseConnectionString?: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn
    ],
    PropretyDisplayName: "Active"
  })
  isActive!: boolean;

  @NavigationProperty({
    PropretyDisplayName: "Related Account",
    PropretyPluralName: "Related Accounts",
    ShowInTab: false,
    AddInplaceProprety: false,
    TargetType: Account
  })
  relatedAccounts?: Account[];

  @NestedProperty({
    PropretyDisplayName: "Related Tenant",
    PropretyPluralName: "Related Tenants",
    ShowInTab: false,
    AddInplaceProprety: false,
    TargetType: Tenant
  })
  relatedTenant?: Tenant;

  @NestedProperty({
    PropretyDisplayName: "Tenant Admin",
    PropretyPluralName: "Tenant Admins",
    ShowInTab: false,
    AddInplaceProprety: false
  })
  adminTenantInfoDTO!: AdminTenantInfoDTO;



  unattachedEmployees?: Employee[];
  unattachedAccounts?: Account[]; 

  GetType(): IEntityMetaData {
    return Client.getMetaData();
  }
}
